module.exports = __webpack_public_path__ + "img/e0bc8a1.png";